import * as React from "react";
import Axios from "../../../Components/Axios";
import moment from "moment";
import Chart from "react-apexcharts";

class Bar2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            error: false,
            service: this.props.service,
            kpInfo: {},
            now: new Date(),
            stat: [],
            type: this.props.type,
            statData: [],
            opacity: 0
        };
    }

    componentDidMount() {

        Axios
            .get('api/services/stat/' + this.state.service + '/sources')
            .then(r => {
                this.setState({
                    now: new Date(r.data.now),
                    stat: r.data.stat
                });

                const sources = [...new Set(r.data.stat.map(v => v.source))];

                let data = sources.map(v => ({
                        data: [...new Array(30)].map((w, i) => {
                                let now = new Date(this.state.now);
                                now.setDate(now.getDate() - i);
                                return {
                                    date: moment(now).format('YYYY-MM-DD'),
                                    count: 0
                                }
                            }).reverse(),
                        source: v
                    })
                );


                r.data.stat.map(v => {
                    let tmp = data.find(w => v.source === w.source).data.find(w => w.date === v.date);
                    (tmp !== undefined) && (tmp.count = v.count);
                });

                this.setState({ statData: data.map(v => ({
                        name: v.source,
                        data: v.data.map(w => w.count)
                    }))
                });

                setTimeout(() =>
                    this.setState({ opacity: 1 }),
                    300
                );
            })
            .catch((e) => {
                console.log(e);
                this.props.history.push('/auth')
            });
    }

    render() {
        return (
            <div className="card shadow border-0 rounded p-2" style={{opacity: this.state.opacity, transition: 'opacity .4s linear'}}>
                <div className="row">
                    <div className="col-12 pl-4 pt-2">
                        <h5>{this.props.title}</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mt-4">
                        <div className="chart-container">
                            <div>
                                <Chart
                                    type = "bar"
                                    series = { this.state.statData ?? [] }
                                    yaxis = {{ show: false}}
                                    height = {350}
                                    options = {
                                        {
                                            chart: {
                                                id: "basic-bar",
                                                toolbar: {show: false},
                                                stacked: true
                                            },
                                            xaxis: {
                                                categories: [...new Array(30)].map((w, i) => {
                                                    let now = new Date(this.state.now);
                                                    now.setDate(now.getDate() - i);
                                                    return moment(now).format('DD');
                                                }).reverse()
                                            },
                                            plotOptions: {
                                                bar: {
                                                    horizontal: false
                                                }
                                            }
                                        }
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}

export default Bar2;